import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErrorIndicatorComponent} from './error-indicator.component';

import '@ui5/webcomponents/dist/Icon.js';

@NgModule({
  declarations: [ErrorIndicatorComponent],
  exports: [
    ErrorIndicatorComponent
  ],
  imports: [
    CommonModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class ErrorIndicatorModule {
}
